import api from "./api";

export type KioskDevice = {
    id: string;
    name: string;
    status: 'PENDING' | 'ACTIVE' | 'REVOKED';
    authorizedAt: string | null;
    lastSeenAt: string | null;
    created_at: string;
    // EMPRESA: mostra todas as usinas da empresa; FILIAL: só as da(s) filial(is) de quem autorizou
    scope?: 'EMPRESA' | 'FILIAL';
};

export const getKioskDevices = async (): Promise<KioskDevice[]> => {
    const response = await api.get(`kiosk/devices`);
    return response.data;
};

export const postAuthorizeKioskDevice = async (body: { code: string; name: string }) => {
    const response = await api.post(`kiosk/authorize`, body);
    return response.data;
};

export const deleteKioskDevice = async (id: string) => {
    const response = await api.delete(`kiosk/devices/${id}`);
    return response.data;
};
